(function () {
  var BP = 990, ROW = 4, GUTTER = 16, OFFSET = 0, MIN_ITEMS = 4;
  var mq = window.matchMedia('(min-width: ' + BP + 'px)');

  function ratioOf(el) {
    var media = el.querySelector('.product__media');
    if (media && media.style.paddingBottom.indexOf('%') > -1) {
      var pb = parseFloat(media.style.paddingBottom);
      if (pb > 0) return pb / 100;
    }
    var cont = el.querySelector('.product-media-container');
    if (cont) {
      var r = parseFloat(getComputedStyle(cont).getPropertyValue('--ratio'));
      if (r > 0) return 1 / r;
    }
    var img = el.querySelector('img');
    if (img && img.naturalWidth > 0) return img.naturalHeight / img.naturalWidth;
    return 1;
  }

  function isVideo(el) {
    return !!el.querySelector(
      '.media-type-video, .media-type-external_video, video, deferred-media'
    );
  }

  function reset(list) {
    list.classList.remove('foko-masonry');
    Array.prototype.forEach.call(list.children, function (el) {
      el.style.removeProperty('grid-row');
      el.style.removeProperty('grid-column');
      el.style.removeProperty('margin-top');
      el.style.removeProperty('align-self');
    });
  }

  function layout(list) {
    var full = list.clientWidth;

    if (!mq.matches || full < BP / 2) { reset(list); return; }

    var items = Array.prototype.slice.call(list.children).filter(function (el) {
      return el.offsetParent !== null;
    });

    var videoIndex = -1, leftIndex = -1, i;

    for (i = 1; i < items.length; i++) {
      if (isVideo(items[i])) { videoIndex = i; break; }
    }
    for (i = 1; i < items.length; i++) {
      if (i !== videoIndex) { leftIndex = i; break; }
    }

    if (items.length < MIN_ITEMS || videoIndex === -1 || leftIndex === -1) {
      reset(list);
      return;
    }

    var half = (full - GUTTER) / 2;

    var spans = items.map(function (el, k) {
      var w = (k === 0) ? full : half;
      var h = w * ratioOf(el);
      var mt = (k === leftIndex) ? OFFSET : 0;
      return Math.max(1, Math.ceil((h + mt + GUTTER) / ROW));
    });

    list.classList.add('foko-masonry');
    var startRow = spans[0] + 1;

    items.forEach(function (el, k) {
      if (k === leftIndex) {
        el.style.setProperty('margin-top', OFFSET + 'px', 'important');
      } else {
        el.style.removeProperty('margin-top');
      }

      if (k === 0) {
        el.style.gridColumn = '1 / -1';
        el.style.gridRow = '1 / span ' + spans[0];
      } else if (k === videoIndex) {
        el.style.gridColumn = '2';
        el.style.gridRow = startRow + ' / span ' + spans[k];
      } else if (k === leftIndex) {
        el.style.gridColumn = '1';
        el.style.gridRow = startRow + ' / span ' + spans[k];
      } else {
        el.style.removeProperty('grid-column');
        el.style.gridRow = 'span ' + spans[k];
      }
    });
  }

  function run() {
    document.querySelectorAll('.product__media-wrapper .product__media-list')
      .forEach(layout);
  }

  var t;
  function later() { clearTimeout(t); t = setTimeout(run, 100); }

  function watch() {
    if (!window.ResizeObserver) return;
    var ro = new ResizeObserver(function (entries) {
      entries.forEach(function (e) {
        var w = Math.round(e.contentRect.width);
        if (e.target.dataset.fokoW === String(w)) return;
        e.target.dataset.fokoW = String(w);
        later();
      });
    });
    document.querySelectorAll('.product__media-wrapper').forEach(function (el) {
      ro.observe(el);
    });
  }

  function boot() {
    run();
    watch();
    [200, 600, 1500].forEach(function (d) { setTimeout(run, d); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', later);
  window.addEventListener('resize', later);
  window.addEventListener('orientationchange', later);
  document.addEventListener('shopify:section:load', function () { later(); watch(); });

  if (mq.addEventListener) mq.addEventListener('change', run);
  else if (mq.addListener) mq.addListener(run);
}());